import { render } from "./MatchCardDesktop.vue?vue&type=template&id=1227f210&scoped=true&lang=true"
import script from "./MatchCardDesktop.vue?vue&type=script&lang=js"
export * from "./MatchCardDesktop.vue?vue&type=script&lang=js"

import "./MatchCardDesktop.vue?vue&type=style&index=0&id=1227f210&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0cc0aef14303b400c-1/assemble-sports/singaporerugby-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1227f210"]])

export default __exports__